import { render, staticRenderFns } from "./client-show.html?vue&type=template&id=0cfcc75c&scoped=true&"
import script from "./client-show.ts?vue&type=script&lang=js&"
export * from "./client-show.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcc75c",
  null
  
)

export default component.exports